import { Prisma } from "@prisma/client"
import { GFADocumentType } from "../files/file-data.internal.vars";

export const gfaOperationTypeToStringMap = {
    VEFA: "VEFA",
    VIR: "VIR",
    CPI: "CPI",
    GENERAL_CONTRACTOR: "Contractant général",
    OTHER: "Autre",
}

export const gfaProcessesTypeToStringMap = {
    CONCRETE: "Béton / Parpaing",
    WOOD: "Ossature Bois",
    METAL: "Ossature Métallique",
    MODULAR_WOOD: "Modulaire Bois",
    MODULAR_METAL: "Modulaire Métallique",
    MODULAR_CONCRETE: "Modulaire Béton",
}


export const gfaConstructionSiteAbilityControlSelect = {
	brokerSocietyId: true,
	constructionSiteOffers: {
		select: {
			binderWarranty: {
				select: {
					binderAmendment: {
						select: {
							binder: {
								select: {
									insurer: {
										select: {
											societyId: true,
										},
									},
								},
							},
						},
					},
				},
			},
		},
	},
} satisfies Prisma.GFAConstructionSiteSelect;
  

export const GFA_DOCUMENT_TYPES = {
	PROMOTER_FILES: [
		"PRESENTATION_HISTORIQUE_SOCIETE",
		"KBIS",
		"STATUTS",
		"DERNIER_BILAN_PROMOTEUR",
		"DERNIER_BILAN_ACTIONNAIRES",
		"DERNIER_BILAN_CONSOLIDE_GROUPE",
		"CV_DIRIGEANTS",
		"COPIE_CNI_DIRIGEANT",
		"ORGANIGRAMME",
		"PRESENTATION_HISTORIQUE_SOCIETE_DERNIERES_OPERATIONS",
		"LISTE_OPERATIONS_EN_COURS",
		"FICHE_PATRIMONIALE_DIRIGEANTS",
	],
	LEGAL_AND_COMMERCIAL_FILES: [
		"ATTESTATION_NOTARIEE_PROPRIETE_FONCIERE",
		"CONTRAT_RESERVATION_TYPE",
		"CALENDRIER_APPEL_DE_FONDS",
		"ATTESTATION_NOTARIEE_PRE_CO",
		"GRILLE_LOTS",
	],
	FINANCIAL_FILES: [
		"BILAN_FINANCIER_OPERATION",
		"PREVISIONNEL_TRESORERIE",
		"JUSTIFICATIF_APPORTS_FONDS_PROPRES",
		"ACCORD_FINANCEMENT",
		"DEBOURSE_TRAVAUX_CORPS_ETAT",
		"RIB_COMPTE_CENTRALISEUR",
	],
	TECHNICAL_FILES: [
		"ARRETES_PERMIS_CONSTRUIRE",
		"PV_CONSTAT_AFFICHAGE",
		"ATTESTATION_NON_RECOURS",
		"NOTICE_DESCRIPTIVE",
		"PLANS_PC",
		"PLANNING_PREVISIONNEL",
		"DECLARATION_OUVERTURE_CHANTIER",
		"CONTRAT_MOE_ATTESTATION_RDC",
		"CONVENTION_CONTROLE_TECHNIQUE",
		"RICT",
		"ETUDE_DE_SOL",
		"DESCRIPTIF_TRAVAUX_CHIFFRES",
		"ATTESTATION_DO_TRC_CNR_RCMO",
		"LISTE_ENTREPRISES_SIREN",
		"DEVIS_OU_MARCHES_SIGNES",
	],
	OPERATION_INFORMATION_FILES: [
		"NOTICE_DESCRIPTIVE",
		"PLANS_PC",
	],
	ADMINISTRATIVE_AUTHORIZATION_FILES: [
		"ARRETES_PERMIS_CONSTRUIRE",
		"PV_CONSTAT_AFFICHAGE",
		"ATTESTATION_NON_RECOURS",
	],
	OPERATION_DATES_FILES: [
		"PLANNING_PREVISIONNEL",
		"DECLARATION_OUVERTURE_CHANTIER",
	],
	INTERVENTION_DETAILS_FILES: [
		"CONTRAT_MOE_ATTESTATION_RDC",
		"CONVENTION_CONTROLE_TECHNIQUE",
		"RICT",
		"ETUDE_DE_SOL",
		"DESCRIPTIF_TRAVAUX_CHIFFRES",
		"ATTESTATION_DO_TRC_CNR_RCMO",
		"LISTE_ENTREPRISES_SIREN",
		"DEVIS_OU_MARCHES_SIGNES",
	],
	OPERATOR_FILES: [],
	SHAREHOLDERS_FILES: [],
	FINANCING_DETAILS_FILES: [],
	FINANCING_COMMERCIALIZATION_PLAN_FILES: [],
	FINANCING_FUND_RAISING_FILES: [],
} as const;

export const SECTION_TITLES = {
	PROMOTER_FILES: "PROMOTEUR",
	LEGAL_AND_COMMERCIAL_FILES: "DOCUMENTS JURIDIQUES ET COMMERCIAUX",
	FINANCIAL_FILES: "BILAN FINANCIER",
	TECHNICAL_FILES: "DOCUMENTS TECHNIQUES",
	
} as const;

export const gfaDocumentTypeLabels: Record<GFADocumentType, string> = {
	PRESENTATION_HISTORIQUE_SOCIETE: "Présentation et historique de la société",
		 KBIS: "KBIS de moins de 3 mois",
		 STATUTS: "Statuts",
		 DERNIER_BILAN_PROMOTEUR : "Dernier bilan du promoteur (annexes + détail des comptes)",
		 DERNIER_BILAN_ACTIONNAIRES: "Derniers bilans des actionnaires (annexes + détail des comptes)",
		 DERNIER_BILAN_CONSOLIDE_GROUPE: "Dernier bilan consolidé du groupe",
		 CV_DIRIGEANTS: "CV du ou des dirigeants",
		 COPIE_CNI_DIRIGEANT: "Copie CNI du dirigeant",
		 ORGANIGRAMME: "Organigramme du groupe",
		 PRESENTATION_HISTORIQUE_SOCIETE_DERNIERES_OPERATIONS: "Présentation et historique de la société (Dernières opérations réalisées)",
		 LISTE_OPERATIONS_EN_COURS: "Liste des opérations en cours avec avancement, commercialisation, fonds propres et financements en cours",
		 FICHE_PATRIMONIALE_DIRIGEANTS: "Fiches patrimoniales des dirigeants validées par le notaire",
		 ATTESTATION_NOTARIEE_PROPRIETE_FONCIERE: "Attestation notariée de propriété du foncier",
		 CONTRAT_RESERVATION_TYPE: "Contrat de réservation type",
		 CALENDRIER_APPEL_DE_FONDS: "Calendrier d'appel de fonds",
		 ATTESTATION_NOTARIEE_PRE_CO: "Attestation notariée de pré commercialisation avec mention des financements purgés",
		 GRILLE_LOTS: "Grille des lots",
		 BILAN_FINANCIER_OPERATION: "Bilan financier de l'opération",
		 PREVISIONNEL_TRESORERIE: "Prévisionnel de trésorerie",
		 JUSTIFICATIF_APPORTS_FONDS_PROPRES: "Justificatifs des apports en fonds propres",
		 ACCORD_FINANCEMENT: "Accord de financement bancaire ou autres (crowd funding, obligations, dation...)",
		 DEBOURSE_TRAVAUX_CORPS_ETAT: "Déboursé des travaux corps d'état par corps d'état",
		 RIB_COMPTE_CENTRALISEUR: "RIB du compte centraliseur",
		 ARRETES_PERMIS_CONSTRUIRE: "Arrêtés de permis de construire, modifications et transferts",
		 PV_CONSTAT_AFFICHAGE: "3 PV de constat d'affichage des PC et modificatifs",
		 ATTESTATION_NON_RECOURS: "Attestation de non recours de la mairie des PC et PCM",
		 NOTICE_DESCRIPTIVE: "Notice descriptive",
		 PLANS_PC: "Plans de PC",
		 PLANNING_PREVISIONNEL: "Planning prévisionnel des travaux",
		 DECLARATION_OUVERTURE_CHANTIER: "Déclaration d'ouverture de chantier",
		 CONTRAT_MOE_ATTESTATION_RDC: "Contrat de maîtrise d'oeuvre + attestation RDC",
		 CONVENTION_CONTROLE_TECHNIQUE: "Convention de contrôle technique",
		 RICT: "RICT",
		 ETUDE_DE_SOL: "Etude de sol",
		 DESCRIPTIF_TRAVAUX_CHIFFRES: "Descriptif des travaux détaillés chiffrés",
		 ATTESTATION_DO_TRC_CNR_RCMO: "Attestation DO TRC CNR RCMO",
		 LISTE_ENTREPRISES_SIREN: "Liste des entreprises intervenants lot par lot avec SIREN",
		 DEVIS_OU_MARCHES_SIGNES: "Devis ou marchés signés des lots du clos-couvert",
		 OTHER_PROMOTER_DOCUMENT: "Autre document du promoteur",
		 OTHER_LEGAL_AND_COMMERCIAL_DOCUMENT: "Autre document juridique et commercial",
		 OTHER_FINANCIAL_DOCUMENT: "Autre document financier",
		 OTHER_TECHNICAL_DOCUMENT: "Autre document technique",
		 OTHER: "Autre",
} as const;